// extracted by mini-css-extract-plugin
export default {"guestSelect__placeholder_text_color":"guestSelect-module__guestSelect__placeholder_text_color___lBCJp"};